import { EdgeAllowances } from '@interfaces/edge-allowances';
import { getCall } from '@services/rest-service';

// Retrieves all the edge allowances from cosmos
export const getEdgeAllowances = (): Promise<EdgeAllowances[]> => {
  return getCall<EdgeAllowances[]>('edge-allowances');
};